import { showResults } from './wheel';
import { resetRecommendationCards } from './recommendations';
import { getData } from './wheel';
import { closeDialog } from '../blocks/archiveDialog';

/**
 * Sets up functionality for dropdown menus in the header
 * @param {NodeList} dropdowns - List of all dropdown elements
 */
const setupDropdowns = (dropdowns) => {
    dropdowns.forEach((dropdown) => {
        dropdown.querySelector('.header__dropdown div.flex').addEventListener('click', (e) => {
            e.stopPropagation();
            dropdowns.forEach((d) => d.classList.toggle('active', d === dropdown && !d.classList.contains('active')));
        });
    });

    document.addEventListener('click', () => dropdowns.forEach((d) => d.classList.remove('active')));
};

/**
 * Sets up functionality for items in the dropdown menu
 * @param {NodeList} items - List of all items in the dropdown menu
 */
const setupItems = (items) => {
    items.forEach((item) => {
        item.addEventListener('click', () => {
            const taxonomy = item.closest('.js-header-filter--taxonomy');
            const taxonomyItems = taxonomy.querySelectorAll('.header__dropdown-item');

            taxonomyItems.forEach((i) => i.classList.remove('active'));
            item.classList.add('active');

            setupDropdownTitle(taxonomy, item);

            let type = false;
            if (checkSearch()) {
                type = 'search';
            }

            showResults(false, type);
        });
    });
};

/**
 * Updates the dropdown menu title based on the selected item
 * @param {HTMLElement} taxonomy - Element containing the dropdown menu
 * @param {HTMLElement} item - Selected item in the dropdown menu
 */
const setupDropdownTitle = (taxonomy, item) => {
    const dropdownTitleHolder = taxonomy.querySelector('.js-header--dropdown-title');
    const dropdownTitle = item.querySelector('span');
    dropdownTitleHolder.textContent = dropdownTitle.textContent;
};

/**
 * Sets up functionality for buttons in the header
 * @param {NodeList} headerButtons - List of all buttons in the header
 * @param {HTMLElement} buttonDisabled - Element indicating the disabled button
 */
const setupHeaderButtons = (headerButtons, buttonDisabled) => {
    headerButtons.forEach((button) => {
        button.addEventListener('click', () => {
            if (button.classList.contains('active')) {
                button.classList.remove('active');
                if (buttonDisabled) buttonDisabled.classList.add('disabled');
            } else {
                headerButtons.forEach((btn) => btn.classList.remove('active'));
                button.classList.add('active');
                if (buttonDisabled) buttonDisabled.classList.remove('disabled');
            }
        });
    });
};

/**
 * Sets up mobile navigation functionality
 * @param {HTMLElement} logo - Logo element
 * @param {HTMLElement} headerFiltering - Header filtering element
 * @param {HTMLElement} headerFilters - Element containing filters
 * @param {HTMLElement} headerSubcat - Element containing subcategories
 * @param {HTMLElement} headerDropdown - Dropdown element in the header
 * @param {HTMLElement} chevronSvg - SVG icon for the chevron
 */
const setupMobileNavigation = (logo, headerFiltering, headerFilters, headerSubcat, headerDropdown, chevronSvg) => {
    const toggleClass = (elem, className) => elem.classList.toggle(className);

    if (logo && headerFiltering) {
        logo.addEventListener('click', (e) => {
            e.preventDefault();
            console.log('clicked');
            if (window.innerWidth <= 1024) {
                chevronSvg.classList.toggle('opened');
            }
        });
    }

    if (headerFilters && headerSubcat) {
        headerFilters.addEventListener('click', () => {
            if (window.innerWidth <= 1024) {
                toggleClass(headerSubcat, 'display');
                toggleClass(headerDropdown, 'bg');
            }
        });
    }
};

/**
 * Main function that initializes all header filter functionality
 * Sets up event listeners on all necessary elements and initializes search
 */
export default function headerFilter() {
    const dropdowns = document.querySelectorAll('.header__dropdown');
    const headerButtons = document.querySelectorAll('.header__button');
    const headerFiltering = document.querySelector('.header__filtering');
    const headerFilters = document.querySelector('.header__filters');
    const headerSubcat = document.querySelector('.header__subcategories');
    const headerDropdown = document.querySelector('.header__text-dropdown');
    const logo = document.querySelector('.logo');
    const chevronSvg = document.querySelector('.header__chevron svg');
    const buttonDisabled = document.querySelector('.button-disabled');
    const items = document.querySelectorAll('.header__dropdown-item');

    setupDropdowns(dropdowns);
    setupItems(items);
    setupHeaderButtons(headerButtons, buttonDisabled);
    setupMobileNavigation(logo, headerFiltering, headerFilters, headerSubcat, headerDropdown, chevronSvg);
    handleSearch();
}

/**
 * Resets all filters to their initial state
 * Returns all dropdown menus to the "All" option and clears the search field
 */
export const resetFilters = () => {
    const texonomies = document.querySelectorAll('.js-header-filter--taxonomy');
    const allFilterItems = document.querySelectorAll('.header__dropdown-item[data-term="all"]');
    texonomies.forEach((taxonomy) => {
        taxonomy.querySelector('.header__dropdown-item.active').classList.remove('active');
        taxonomy.querySelector('.js-header--dropdown-title').textContent = 'All';
    });

    allFilterItems.forEach((item) => {
        item.classList.add('active');
    });

    clearSearch();
    resetRecommendationCards();

    if (window.innerWidth <= 1024) {
        closeDropdowns;
    }
};

export function clearSearch() {
    const searchInput = document.querySelector('.js-header--search');
    searchInput.value = '';
}

function checkSearch() {
    const searchInput = document.querySelector('.js-header--search');
    if (searchInput.value) {
        return true;
    }

    return false;
}

export const closeDropdowns = () => {
    const headerSubcat = document.querySelector('.header__subcategories');
    const headerDropdown = document.querySelector('.header__text-dropdown');
    headerSubcat.classList.remove('display');
    headerDropdown.classList.remove('bg');
};

/**
 * Updates the logo and title in the header
 * @param {string} logoSrc - Path to the new logo image
 * @param {string} categoryName - Category name
 */
export const updateHeaderLogo = (logoSrc, categoryName) => {
    const logo = document.querySelector('.js-header--logo');
    const title = document.querySelector('.js-header--title');
    logo.src = logoSrc;
    logo.alt = categoryName;
    title.textContent = categoryName;
};

/**
 * Sets up search functionality in the header
 * Initializes event listener for the Enter key in the search field
 */
export const handleSearch = () => {
    const searchInput = document.querySelector('.js-header--search');
    const searchIcon = document.querySelector('.header__search');
    const searchButton = document.querySelector('.js-header--search-btn');
    const searchArrow = document.querySelector('.header__search-arrow');

    const performSearch = () => {
        showResults(true, 'search');
        closeDropdowns();
        updateHeaderLogo(menaObject.svgItems + '/search.svg', 'Search');

        if (document.body.classList.contains('single-is-open')) {
            closeDialog();
        }

        if (typeof gtag !== 'undefined') {
            const data = getData('search');
            gtag('event', 'view_results', {
                event_category: 'wheel_interaction',
                event_label: data.categoryTitle,
                custom_parameters: {
                    category_id: data.categoryId,
                    search_query: data.searchQuery,
                    subcategories: JSON.stringify(data.subcategories),
                    segment_title: data.categoryTitle,
                },
            });
        }
    };

    if (searchInput) {
        searchInput.addEventListener('keyup', (e) => {
            if (e.key === 'Enter') {
                performSearch();
            }
        });
    }

    // Make the existing search icon act as a submit button (mobile-friendly)
    if (searchIcon) {
        searchIcon.setAttribute('role', 'button');
        searchIcon.setAttribute('tabindex', '0');
        searchIcon.addEventListener('click', () => {
            performSearch();
        });
        searchIcon.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                performSearch();
            }
        });
    }

    // New mobile arrow button (visible under 1024px)
    const applyButtonVisibility = () => {
        if (!searchButton) return;
        if (window.innerWidth <= 1024) {
            searchButton.style.display = 'block';
        } else {
            searchButton.style.display = 'none';
        }
    };

    if (searchButton) {
        searchButton.addEventListener('click', () => {
            performSearch();
        });
        searchButton.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                performSearch();
            }
        });

        // Rotate dropdown SVG to act as a right arrow
        if (searchArrow) {
            searchArrow.style.transform = 'rotate(-90deg)';
            searchArrow.style.width = '14px';
            searchArrow.style.height = '14px';
        }

        applyButtonVisibility();
        window.addEventListener('resize', applyButtonVisibility);
    }
};
